import React, {
  forwardRef, useEffect, useState,
} from 'react';

import type { PopoverWithButtonProps } from '@vlabs/monokit/shared/ui/popovers';
import { PopoverWithButton } from '@vlabs/monokit/shared/ui/popovers';
import { Control } from '@vlabs/uikit';
import { useTranslation } from 'react-i18next';

import { useListListPageFilters } from '../../useListListPageFilters';

function NameFilterPopover(
  props: PopoverWithButtonProps,
  ref: React.ForwardedRef<HTMLDivElement>,
) {
  const { t } = useTranslation();
  const [localValue, setLocalValue] = useState('');
  const { filters, updateFilters, updateFiltersDebounced } = useListListPageFilters();

  const reset = () => updateFilters({ user_data: undefined });

  const onChangeHandler = (user_data: string) => {
    setLocalValue(user_data);
    updateFiltersDebounced({ user_data: user_data.length > 0 ? user_data : undefined });
  };

  useEffect(() => {
    setLocalValue(filters.user_data ?? '');
  }, [filters.user_data]);

  return (
    <PopoverWithButton
      {...props}
      onClickReset={reset}
      ref={ref}
      title={<div className="Body-2">{t('list-list-page:filters.popovers.name.label')}</div>}
    >
      <Control.Input
        isClearable
        onChangeValue={onChangeHandler}
        onClear={reset}
        value={localValue}
      />
    </PopoverWithButton>
  );
}

const NameFilterPopoverWithRef = forwardRef(NameFilterPopover);
export { NameFilterPopoverWithRef as NameFilterPopover };
